import IUserGet from 'api/interfaces/users/IUserGet';
import IProject from '../../../interfaces/IProject';

export const allowedToWriteOwnOrganizationConfiguration = (
  user: IUserGet,
  project: IProject | undefined
): boolean => {
  if (user == null || project == null || user.organizationUnit == null) {
    return false;
  }

  return (
    user.allowedToWriteOrganizationUnitProjects &&
    project.organizationUnitId === user.organizationUnit.id
  );
};
